import * as types from './mutation-types'

export default {
  [types.RESET_CURRENT_USER] (state, user) {
    state.currentUser = null
  },
  [types.BOOTSTRAP_ACCOUNT_TYPES](state, user) {
    state.accountTypes = user
  },
  [types.BOOTSTRAP_DEFAULT_ACCOUNT](state, user) {
    state.defaultAccount = user
  },
  
  [types.BOOTSTRAP_ROLE_TYPES](state, role) {
    state.roleTypes = role
  },
  [types.BOOTSTRAP_DEFAULT_ROLE](state, role) {
    state.defaultRole = role
  },
  [types.BOOTSTRAP_STATUS_TYPES](state, role) {
    state.statusTypes = role
  },
  [types.BOOTSTRAP_DEFAULT_STATUS](state, defaultStatus) {
    state.defaultStatus = defaultStatus
  },
  [types.BOOTSTRAP_DEFAULT_COUNTRY](state, defaultCountry) {
    state.defaultCountry = defaultCountry
  },

  [types.BOOTSTRAP_CURRENT_USER] (state, user) {
    state.currentUser = user
  },
  [types.UPDATE_CURRENT_USER] (state, user) {
    state.currentUser = user
  }
}
